import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { PLAYERS_PERMISSIONS } from '@modules/players/constants';
import { ADMIN_PLAYER_PROFILE_ROUTE_NAME, PLAYER_TRACKING_HISTORY_EDIT_ROUTE_NAME } from '@modules/players/submodules/PlayerProfile/constants';
import {
  PLAYER_TRACKER_ROUTE,
  TRANSLATION_GROUP_PLAYER_TRACKER,
} from '@modules/players/submodules/PlayerProfile/submodules/PlayerTracker/constants';
import { getTranslationKeys } from '@modules/players/submodules/PlayerProfile/submodules/PlayerTracker/translations';

export class PlayerTrackerModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYER_PROFILE_ROUTE_NAME, {
      name: PLAYER_TRACKER_ROUTE,
      path: 'player_tracker',

      component: () => import('@modules/players/submodules/PlayerProfile/submodules/PlayerTracker/pages/PlayerTrackerPage/PlayerTrackerPage.vue'),
      permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
    });

    router.addChildRoute(PLAYER_TRACKER_ROUTE, {
      name: PLAYER_TRACKING_HISTORY_EDIT_ROUTE_NAME,
      path: 'change_history/:historyId/:merchant',
      component: () => import('@modules/players/submodules/PlayerProfile/pages/PlayerTrackingHistoryEditPage/PlayerTrackingHistoryEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_PLAYER_TRACKER, getTranslationKeys);
  }
}
